import { render, staticRenderFns } from "./blog-posts.vue?vue&type=template&id=2f3d9490&scoped=true&"
import script from "./blog-posts.vue?vue&type=script&lang=js&"
export * from "./blog-posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d9490",
  null
  
)

export default component.exports